import { Button } from 'react-bootstrap';
import styled from 'styled-components';

export const CommentForwardButtonContainer = styled(Button)`
  font-size: 10px;
  border-radius: 6px;
  padding: 0.25rem 0.5rem;
  margin-right: 10px;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: ${(props) => (props.isSelected ? '#fff' : '#5e72e4')};
  background-color: ${(props) =>
    props.isSelected ? '#5e72e4' : 'transparent'};
  border: 1px solid #5e72e4;

  &:hover {
    color: ${(props) => (props.isSelected ? '#fff' : '#2c4ae2')};
    background-color: ${(props) =>
      props.isSelected ? '#2c4ae2' : 'rgba(94, 114, 228, 0.1)'};
    border-color: #2c4ae2;
  }

  svg {
    transition: transform 0.2s ease;
  }

  &:hover svg {
    transform: scale(1.1);
  }
`;
